export const parseJson = <T>(value: string): T => JSON.parse(value) as T;

export const readJson = <T>(response: Response): Promise<T> => response.json() as Promise<T>;
